// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1fg0C","select":"Header_select__1Vq0M","clinic":"Header_clinic__2bloY"};